import api from '../../api/api_resource'

const state = {
    all: [],
    current_page: 1,
    per_page: 1000,
    from: 1,
    to: 50,
    last_page: null,
    total: null,
};

// getters
const getters = {
    all: (state, getters, rootState) => {
        return state.all;
    }
};

// actions
const actions = {
    async getAll({ commit, state }, args) {
        const search_args = Object.assign({
            page: state.current_page,
            per_page: state.per_page
        }, args);
        let result = await api.index('auto-notices', search_args)
        commit('setAutoNotice', result)
        return result;
    },
    async destroy({ commit, state }, id){
        let result = false;
        try {
            result = await api.destroy('auto-notices', id);
            commit('removeAutoNotice', id);
        } catch (e) {
            //
        }
        return result
    },
    async save({ commit, state }, data){
        let res;
        if (data.id) {
            res = api.update('auto-notices', data, data.id);
        } else {
            res = api.store('auto-notices', data);
        }
        return res;
    },
};

// mutations
const mutations = {
    setAutoNotice (state, result) {
        state.all = result.data;
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
        state.from = result.from;
        state.to = result.to;
        state.last_page = result.last_page;
        state.total = result.total;
    },
    removeAutoNotice (state, id) {
        let found = false;
        state.all.forEach((item, index) => {
            if (item.id === id) {
                found = index;
            }
        });
        if (found !== false) {
            state.all.splice(found, 1);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/auto_notices.js